import { inject, Injectable } from '@angular/core';
import { CreateProjectModel } from '@app/components/company/company-projects/create-project-dialog/create-project-form-controls';
import { AuthService } from '@app/shared/services/auth.service';
import { ProjectDTO } from '@app/shared/services/dtos/project/project.dto';
import { ProjectsDataService } from '@app/shared/services/projects-data.service';
import { Currency } from '@app/shared/types/enums/currency.enum';
import { TimeUnits } from '@app/shared/types/enums/time-units.enum';
import { CreateProjectDTO } from '@app/shared/types/models/project/dto/create-project-dto';
import { Observable } from 'rxjs';

@Injectable()
export class CreateProjectService {
  private readonly authService: AuthService = inject(AuthService);
  private readonly projectService: ProjectsDataService = inject(ProjectsDataService);

  private getHours(amount: number | null, units: TimeUnits): number | null {
    if (units === TimeUnits.MAN_DAYS) {
      return amount * 8;
    }
    return amount;
  }

  public createInitialModel(): CreateProjectModel {
    return {
      name: '',
      avatarId: '',
      description: '',
      supervisor: this.authService.currentUser() ?? null,
      client: null,
      startDate: null,
      endDate: null,
      estimation: {
        financial: { amount: 0, currency: Currency.PLN },
        time: { amount: 0, units: TimeUnits.HOURS }
      },
      address: ''
    };
  }

  public saveProject(model: CreateProjectModel): Observable<ProjectDTO> {
    const projectDTO: CreateProjectDTO = {
      address: model.address,
      avatarId: model.avatarId,
      clientId: model.client?.id,
      description: model.description,
      endDate: model.endDate,
      estimation: {
        hours: this.getHours(model.estimation.time.amount, model.estimation.time.units),
        financial: {
          amount: Number(model.estimation.financial.amount),
          currency: model.estimation.financial.currency
        }
      },
      name: model.name,
      startDate: model.startDate,
      supervisorId: model.supervisor?.id
    };
    return this.projectService.createProject(projectDTO);
  }
}
